




































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Validations } from 'vuelidate-property-decorators';
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from 'vuelidate/lib/validators';
import MaskedInput from 'vue-masked-input';
import Navigator from '../Study/Navigator.vue';
import { bus, store, client } from '../../shared';
import { supportTypes } from '../../shared/constants';
import { DeleteDataProjectMiscDoc } from '../../shared/dataProject';
import { ToggleButton } from 'vue-js-toggle-button';
import _ from 'lodash';
@Component({
  components: {
    MaskedInput,
    ToggleButton,
  },
})
export default class DataRepoProject extends Vue {
  $v: any;
  file: any = [];
  endDate: any = '';
  supportTypeOptions: any = supportTypes;
  supportType: any = [];
  remaincharactersText = '';
  hasResearchArea: boolean = false;
  form: any = {
    projectTitle: '',
    projectSummary: '',
    fundingAvailable: false,
    supportType: '',
    supportTypeOther: '',
    grantNumber: '',
    projectEndMonth: '',
    projectEndYear: '',
    projectEndDate: '',
    cellStimulus: false,
    cellDeath: false,
    type1Diabetes: false,
    tissueEngineering: false,
    alphaCells: false,
    geneticsGenomics: false,
    otherArea: false,
    otherAreaText: '',
    role: '',
    part1complete: false,
    part2complete: false,
  };
  @Validations()
  validations: any = {
    form: {
      projectTitle: { required },
      projectSummary: { required },
      fundingAvailable: { required },
      supportType: {
        requiredIf: requiredIf((form: any) => form.fundingAvailable === true),
      },
      supportTypeOther: {
        requiredIf: requiredIf((form: any) => form.supportType === -9),
      },
      // supportTypeOther: {
      //    requiredIf: requiredIf((form: any) => form.supportType !== null && form.supportType !== '-9'),
      // },
      grantNumber: {
        requiredIf: requiredIf(
          (form: any) =>
            form.fundingAvailable &&
            form.supportType !== 7 &&
            form.supportType !== 8 &&
            form.supportType !== 9 &&
            form.supportType !== -9,
        ),
      },
      projectEndMonth: { required },
      projectEndYear: { required },
      projectEndDate: {
        required,
        validDate: (value: any, vm: any) => {
          if (value.indexOf('_') === -1) {
            const [monthStr, yearStr] = value.split('/');
            const month = parseInt(monthStr, 10);
            const year = parseInt(yearStr, 10);
            if (!month || !year || month < 1 || month > 12 || year < 1000) {
              return false;
            }
            const now = new Date();
            const currentMonth = now.getMonth() + 1;
            const currentYear = now.getFullYear();
            if (
              year < currentYear ||
              (year === currentYear && month < currentMonth)
            ) {
              return false;
            }
            return true;
          }
          return false;
        },
      },
      cellStimulus: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.type1Diabetes &&
            !form.tissueEngineering &&
            !form.alphaCells &&
            !form.geneticsGenomics &&
            !form.otherArea,
        ),
      },
      cellDeath: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellStimulus &&
            !form.type1Diabetes &&
            !form.tissueEngineering &&
            !form.alphaCells &&
            !form.geneticsGenomics &&
            !form.otherArea,
        ),
      },
      type1Diabetes: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.cellStimulus &&
            !form.tissueEngineering &&
            !form.alphaCells &&
            !form.geneticsGenomics &&
            !form.otherArea,
        ),
      },
      tissueEngineering: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.type1Diabetes &&
            !form.cellStimulus &&
            !form.alphaCells &&
            !form.geneticsGenomics &&
            !form.otherArea,
        ),
      },
      alphaCells: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.type1Diabetes &&
            !form.tissueEngineering &&
            !form.cellStimulus &&
            !form.geneticsGenomics &&
            !form.otherArea,
        ),
      },
      geneticsGenomics: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.type1Diabetes &&
            !form.tissueEngineering &&
            !form.alphaCells &&
            !form.cellStimulus &&
            !form.otherArea,
        ),
      },
      otherArea: {
        requiredIf: requiredIf(
          (form: any) =>
            !form.cellDeath &&
            !form.type1Diabetes &&
            !form.tissueEngineering &&
            !form.alphaCells &&
            !form.geneticsGenomics &&
            !form.cellStimulus,
        ),
      },
      otherAreaText: {
        requiredIf: requiredIf((form: any) => this.form.otherArea === true),
      },
    },
  };
  @Prop({ default: false }) resetFile: boolean;

  @Watch('form.fundingAvailable')
  onFundingAvailableChanged(newValue: boolean, oldValue: boolean) {
    if (newValue === false) {
      this.form.supportType = null;
      this.form.supportTypeOther = null;
      this.form.grantNumber = null;
    }
  }
  @Watch('form.projectEndDate')
  onProjectEndDateChanged(value: any) {
    this.$v.form.projectEndDate.$touch();
  }
  @Watch('form.supportType')
  public onSupportChanged(newValue: any, oldValue: any) {
    if (newValue !== -9) {
      this.form.supportTypeOther = null;
    }
  }
  @Watch('form.projectTitle')
  public onProjectTitleChanged(value: any) {
    if (value === '') {
      this.form.projectTitle = null;
    }
  }
  @Watch('form.projectSummary')
  public onProjectSummaryChanged(value: any) {
    if (value === '') {
      this.form.projectSummary = null;
    }
  }
  @Watch('form.grantNumber')
  public onGrantNumberChanged(value: any) {
    if (value === '') {
      this.form.grantNumber = null;
    }
  }
  @Watch('form.supportTypeOther')
  public onSupportTypeOtherChanged(value: any) {
    if (value === '') {
      this.form.supportTypeOther = null;
    }
  }
  @Watch('form.otherAreaText')
  public onOtherAreaTextChanged(value: any) {
    if (value === '') {
      this.form.otherAreaText = null;
    }
  }
  /* ------------- Props ------------------- */
  /* ------------- Computed ---------------- */
  /* ------------- Methods ----------------- */
  processEndDate() {
    const md = this.form.projectEndDate.split('/');
    if (md.length === 2) {
      this.form.projectEndMonth = md[0];
      this.form.projectEndYear = md[1];
    }
    this.$v.$touch();
    this.submit();
  }
  get userInfo() {
    return store.userInfo;
  }
  remaincharCount() {
    if (
      this.form.projectSummary !== null &&
      this.form.projectSummary !== '' &&
      this.form.projectSummary.length > 750
    ) {
      this.form.remaincharactersText = 'Exceeded ' + 750 + ' characters limit.';
    } else {
      if (
        this.form.projectSummary !== null &&
        this.form.projectSummary !== ''
      ) {
        const remainCharacters = 750 - this.form.projectSummary.length;
        this.remaincharactersText =
          'Remaining ' + remainCharacters + ' characters.';
      }
    }
  }
  /* ------------- Lifecycle Hooks --------- */
  submit() {
    this.$v.$touch();
    this.$emit('update', {
      formData: this.form,
      id: 2,
      file: this.file,
      isValid: !this.$v.$invalid,
    });
  }
  onFileChange(imgFile: any) {
    if (imgFile != null) {
      const checkDuplicate = _.findIndex(
        this.userInfo.data.docs,
        (o: any) => o.docName === imgFile.name,
      );
      if (checkDuplicate !== -1) {
        this.$swal({
          icon: 'error',
          title: 'Duplicate file detected',
          text:
            'File selection cannot proceed because a file with similar name has been previously uploaded.',
        });
        this.file = [];
      } else {
        this.file = imgFile;
        setTimeout(() => {
          this.submit();
        }, 500);
        setTimeout(() => {
          this.loadToForm();
        }, 20000);
      }
    }
  }
  activated() {
    if (
      this.userInfo.data !== undefined &&
      this.userInfo.data.form !== undefined
    ) {
      Object.assign(this.form, this.userInfo.data.form);
      this.loadEndDate();
    }
  }
  validateForm() {
    return this.$v.$invalid;
  }
  mounted() {
    this.loadEndDate();
    this.loadToForm();
    this.validateForm();
  }

  loadEndDate() {
    this.endDate = `${this.form.projectEndMonth}/${this.form.projectEndYear}`;
    this.form.projectEndDate = `${this.form.projectEndMonth}/${this.form.projectEndYear}`;
  }
  loadToForm() {
    bus.$on('userInfo', (payload: any) => {
      Object.assign(this.form, payload.data.form);
    });
  }
  clearFiles() {
    (this.$refs.inputFile as any).reset();
    this.loadToForm();
  }
  confirmDelete(rec: any) {
    this.$swal({
      title: 'Confirm Delete',
      text:
        'You will not be able to recover this uploaded file. Do you wish to proceed?',
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn btn-danger m-1',
        cancelButton: 'btn btn-secondary m-1',
      },
      confirmButtonText: 'Yes, delete it!',
      html: false,
      preConfirm: () => {
        return new Promise((resolve: any) => {
          setTimeout(() => {
            resolve();
          }, 50);
        });
      },
    }).then(async (result: any) => {
      if (result.value) {
        const d = await client.delete(
          new DeleteDataProjectMiscDoc({
            docId: rec.docId,
            dataProjectRowId: rec.dataProjectRowId,
          }),
        );
        this.userInfo.data.docs = d.docs;
        if (d !== undefined) {
          this.$swal('Deleted!', 'Uploaded file has been deleted.', 'success');
        }
      } else if (result.dismiss === 'cancel') {
        this.$swal('Cancelled', 'Delete operation is cancelled.', 'error');
      }
    });
  }
  public researchCheckBoxChanged(changed: any) {
    if (
      this.form.cellDeath === true ||
      this.form.cellStimulus === true ||
      this.form.type1Diabetes === true ||
      this.form.tissueEngineering === true ||
      this.form.alphaCells === true ||
      this.form.geneticsGenomics === true ||
      this.form.otherArea === true
    ) {
      this.$emit('research-area-changed', true);
    } else {
      this.$emit('research-area-changed', false);
    }
  }
}
